import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const StaffActiveRoute = () => {
  const { user, role } = useAuth();

  if (role === 'SALON_STAFF' && user?.staffRegistrationRejected) {
    return <Navigate to="/staff/registration-rejected" replace />;
  }

  if (role === 'SALON_STAFF' && user?.staffPendingApproval) {
    return <Navigate to="/staff/pending-approval" replace />;
  }

  return <Outlet />;
};

export default StaffActiveRoute;
